import { render, staticRenderFns } from "./ShippingLogBLDetailLegVesselPop.vue?vue&type=template&id=c548ec40"
import script from "./ShippingLogBLDetailLegVesselPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLDetailLegVesselPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c548ec40')) {
      api.createRecord('c548ec40', component.options)
    } else {
      api.reload('c548ec40', component.options)
    }
    module.hot.accept("./ShippingLogBLDetailLegVesselPop.vue?vue&type=template&id=c548ec40", function () {
      api.rerender('c548ec40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLDetailLegVesselPop.vue"
export default component.exports